/**
 * Component that shows payment method warnings in a card-like style.
 */
angular.module('hjApp.account').component('paymentMethodWarningCard', {
    bindings: {
        failedAttemptsCount: '<',
        expirationDate: '<',
        paymentMethodLabel: '<',
        paymentMethodType: '<'
    },
    template: require('./payment-method-warning-card.component.html'),
    controller: [
        '$filter',
        function ($filter) {
            /******************************
             * PRIVATE PROPERTIES
             ******************************/
            var self = this;

            /******************************
             * PRIVATE FUNCTIONS
             ******************************/
            function isCardExpiringSoon() {
                var daysUntilCardExpiration = $filter('daysFromNow')(self.expirationDate);
                return self.paymentMethodType === 'credit_card' && daysUntilCardExpiration <= 30;
            }

            /******************************
             * PUBLIC PROPERTIES
             ******************************/
            /**
             * Run on component initialization.
             */
            self.$onInit = function () {
                self.cardWillSoonExpire = isCardExpiringSoon();
            };
        }
    ]
});
